module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN401_273344906.ffe7c045.png";